import {
  Lit3formBlock,
  html,
  unsafeHTML,
  classMap,
} from '@Root/lib/lit-3form-block';
import { styles } from './css';

import { analyticsCtaDataObject } from '../../../helpers/adobe-analytics';

import { vimeoIdFrom } from '@Helpers/vimeo-video';

export class Corwin extends Lit3formBlock {
  static get characterName() {
    return 'corwin';
  }

  static get characterProperties() {
    return {
      _ctaList: { type: Array },
    };
  }

  static get characterStyles() {
    return [...styles];
  }

  constructor() {
    super();
    this.setCtaList();
  }

  render() {
    return html`
      <div class="block-wrapper">
        <div class="${classMap(this.layoutClasses)}">
          <div class="${classMap(this.detailsClasses)}">
            ${this.headerHTML} ${this.descriptionHTML} ${this.ctaHTML}
          </div>
          ${this.videoId
            ? html`
                <div class="video">
                  ${this.useColumnLayout
                    ? html`
                        <vimeo-video
                          videoid="${this.videoId}"
                          videoWidth="1500"
                          fitaspect
                        ></vimeo-video>
                        <div></div>
                      `
                    : html`
                        <vimeo-video
                          videoid="${this.videoId}"
                          fitaspect
                        ></vimeo-video>
                      `}
                </div>
              `
            : html`
                <div class="image">
                  <img src="${this.imageUrl}" />
                  ${this.imageDescriptionHTML}
                </div>
              `}
          ${this.horizontalRule}
        </div>
      </div>
    `;
  }

  get layoutClasses() {
    const classes = {
      'block-grid': true,
    };
    this.useColumnLayout
      ? (classes['corwin-layout-column'] = true)
      : (classes['corwin-layout-default'] = true);
    return classes;
  }

  get useColumnLayout() {
    return this.content.column_layout === '1';
  }

  get detailsClasses() {
    const classes = {
      details: true,
    };

    if (this.useColumnLayout) {
      classes[`column-direction`] = true;
    }

    const verticalAlignment = this.content.vertical_text_alignment || 'top';
    classes[`vertical-${verticalAlignment}`] = true;

    return classes;
  }

  get headerHTML() {
    return this.headerText
      ? html`
          <h2 class="header">${unsafeHTML(this.headerText)}</h2>
        `
      : ``;
  }

  get descriptionHTML() {
    return this.descriptionText
      ? html`
          <p class="description">${unsafeHTML(this.descriptionText)}</p>
        `
      : ``;
  }

  get ctaHTML() {
    return this._ctaList.length
      ? this.useColumnLayout
        ? html`
            <div class="cta-list">
              ${this._ctaList.map(cta => {
                const ctaInfo = JSON.stringify(cta);
                return html`
                  <cta-text
                    class="cta-btn"
                    cta-data=${ctaInfo}
                    .ctaAnalyticsData=${analyticsCtaDataObject(
                      ctaInfo,
                      this.headerText
                    )}
                  ></cta-text>
                `;
              })}
            </div>
          `
        : html`
            <div class="cta-list">
              ${this._ctaList.map(cta => {
                const ctaInfo = JSON.stringify(cta);
                return html`
                  <cta-button
                    cta-data=${ctaInfo}
                    cta-type=${this.ctaType(cta)}
                    .ctaAnalyticsData=${analyticsCtaDataObject(
                      ctaInfo,
                      this.headerText
                    )}
                  ></cta-button>
                `;
              })}
            </div>
          `
      : ``;
  }

  setCtaList() {
    let ctaList = [];
    if (this.content.cta || this.content.call_to_actions) {
      const ctaListFromContent = this.content.call_to_actions || [];
      const ctaObj = this.content.cta;
      if (ctaObj.url && ctaObj.text) {
        ctaObj['type'] = 'Primary Button';
        ctaListFromContent.unshift(ctaObj);
      }

      ctaListFromContent.forEach(cta => {
        cta['fullWidth'] = true;
      });
      ctaList = [...ctaListFromContent];
    }
    this._ctaList = ctaList;
  }

  ctaType(cta) {
    return cta.type.toLowerCase().split(' ')[0];
  }

  get hasCta() {
    return this.content.cta && !!this.content.cta.text;
  }

  get videoId() {
    return vimeoIdFrom(this.content.video_url);
  }

  get imageUrl() {
    return !!this.content.image
      ? this.imagebossUrl(this.content.image.src, null, 750)
      : '';
  }

  get fullResolutionImageUrl() {
    return !!this.content.image ? this.content.image.full_resolution_src : '';
  }

  get imageDescriptionHTML() {
    return !!this.imageDescription
      ? html`
          <image-caption
            description=${this.imageDescription}
            file-url=${this.fullResolutionImageUrl || ''}
            placement=${this.headerText}
          ></image-caption>
        `
      : html``;
  }

  get imageDescription() {
    return !!this.content.image?.description
      ? this.withLineBreaks(this.content.image.description)
      : '';
  }
}
Corwin.defineElement();
